import React from 'react';
import { styled } from '@compiled/react';
// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
import { graphql, useFragment } from 'react-relay';
import { statusCategoryForId } from '@jira/platform__status-categories/src/status-categories.tsx';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';
import StatusLozenge from '@atlassian/jira-common-components-status-lozenge/src/view.tsx';
import type { status_softwareReleasesVersionDetailIssueList$key } from '@atlassian/jira-relay/src/__generated__/status_softwareReleasesVersionDetailIssueList.graphql';

type Props = {
	jiraStatusField: status_softwareReleasesVersionDetailIssueList$key;
};

export const Status = ({ jiraStatusField }: Props): React.JSX.Element => {
	const { status } = useFragment(
		// eslint-disable-next-line jira/graphql/restrict-graphql-in-unnamed-files
		graphql`
			fragment status_softwareReleasesVersionDetailIssueList on JiraStatusField {
				status @required(action: THROW) {
					name @required(action: THROW)
					description
					statusCategory @required(action: THROW) {
						statusCategoryId @required(action: THROW)
					}
				}
			}
		`,
		jiraStatusField,
	);

	return (
		<Tooltip
			content={
				<>
					<StatusName>{status.name}</StatusName>
					{status.description != null && status.description.length > 0 && (
						<StatusDescription>{status.description}</StatusDescription>
					)}
				</>
			}
		>
			<StatusLozenge
				name={status.name}
				category={statusCategoryForId(status.statusCategory.statusCategoryId)}
			/>
		</Tooltip>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusName = styled.p({
	fontWeight: token('font.weight.bold'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StatusDescription = styled.p({
	marginTop: token('space.050'),
});
